module.exports = __webpack_public_path__ + "static/about-illiustration-706bf017ccfd8ca58fd2d04c61bf1856.jpg";